// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import UserFilterController from "./user_filter_controller"
application.register("user-filter", UserFilterController)
import HighlightTapsController from "./highlight_taps_controller"
application.register("highlight-taps", HighlightTapsController)
import TenantTermsController from "./tenant_terms_controller"
application.register("tenant-terms", TenantTermsController)
import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)
import PiratResetDialogController from "./pirat_reset_dialog_controller"
application.register("pirat-reset-dialog", PiratResetDialogController)
import InvoiceHelpController from "./invoice_help_controller"
application.register("invoice-help", InvoiceHelpController)
import LiveUpdatesController from "./live_updates_controller"
application.register("live-updates", LiveUpdatesController)
import AppInstallController from "./app_install_controller"
application.register("app-install", AppInstallController)

import HelloController from "./hello_controller"
import FinanceMemberSearchController from "./finance_member_search_controller"
application.register("finance-member-search", FinanceMemberSearchController)
import AdminUserSearchController from "./admin_user_search_controller"
import MemberSearchHelpController from "./member_search_help_controller"
application.register("member-search-help", MemberSearchHelpController)
import NavbarUserSearchController from "./navbar_user_search_controller"
application.register("navbar-user-search", NavbarUserSearchController)
import TenantAffiliationController from "./tenant_affiliation_controller"
import TenantNavigationController from "./tenant_navigation_controller"
application.register("tenant-navigation", TenantNavigationController)
import TenantCommunicationsController from "./tenant_communications_controller"
import AddressFormController from "./address_form_controller"
import BookableSpacesFormController from "./bookable_spaces_form_controller"
import ClipboardController from "./clipboard_controller"
import DuprConnectController from "./dupr_connect_controller"
import ImagePreviewController from "./image_preview_controller"
import IncidentReportToggleController from "./incident_report_toggle_controller"
import IncidentReportFormController from "./incident_report_form_controller"
import VenueLodgementController from "./venue_lodgement_controller"
application.register("venue-lodgement", VenueLodgementController)
import MenuDropdownController from "./menu_dropdown_controller"
import MobilePrefixController from "./mobile_prefix_controller"
import PlayerSortController from "./player_sort_controller"
import TeamOrderController from "./team_order_controller"
application.register("team-order", TeamOrderController)
import ProfileStatusController from "./profile_status_controller"
import PublicGroupSearchController from "./public_group_search_controller"
import SessionFormController from "./session_form_controller"
import SessionsLocationFilterController from "./sessions_location_filter_controller"
import SweetalertConfirmController from "./sweetalert_confirm_controller"
import TenantRoleFilterController from "./tenant_role_filter_controller"
import TomSelectController from "./tom_select_controller"
import TournamentGenderController from "./tournament_gender_controller"
import VenueCalendarController from "./venue_calendar_controller"
import VenueBookingCalendarController from "./venue_booking_calendar_controller"
import VenueClosingHoursCalendarController from "./venue_closing_hours_calendar_controller"
import VenueNoAccessCalendarController from "./venue_no_access_calendar_controller"
import VenueWeeklyAllocationCalendarController from "./venue_weekly_allocation_calendar_controller"
application.register("admin-user-search", AdminUserSearchController)
application.register("address-form", AddressFormController)
application.register("tenant-affiliation", TenantAffiliationController)
application.register("tenant-communications", TenantCommunicationsController)
application.register("bookable-spaces-form", BookableSpacesFormController)
application.register("clipboard", ClipboardController)
application.register("dupr-connect", DuprConnectController)
application.register("hello", HelloController)
application.register("image-preview", ImagePreviewController)
application.register("incident-report-toggle", IncidentReportToggleController)
application.register("incident-report-form", IncidentReportFormController)
application.register("menu-dropdown", MenuDropdownController)
application.register("mobile-prefix", MobilePrefixController)
application.register("player-sort", PlayerSortController)
application.register("profile-status", ProfileStatusController)
application.register("public-group-search", PublicGroupSearchController)
application.register("session-form", SessionFormController)
application.register("sessions-location-filter", SessionsLocationFilterController)
application.register("sweetalert-confirm", SweetalertConfirmController)
application.register("tenant-role-filter", TenantRoleFilterController)
application.register("tom-select", TomSelectController)
application.register("tournament-gender", TournamentGenderController)
application.register("venue-calendar", VenueCalendarController)
application.register("venue-booking-calendar", VenueBookingCalendarController)
application.register("venue-closing-hours-calendar", VenueClosingHoursCalendarController)
application.register("venue-no-access-calendar", VenueNoAccessCalendarController)
application.register("venue-weekly-allocation-calendar", VenueWeeklyAllocationCalendarController)

import PasskeyController from "./passkey_controller"
application.register("passkey", PasskeyController)

import LogoIntroController from "./logo_intro_controller"
application.register("logo-intro", LogoIntroController)

import ResultHistoryController from "./result_history_controller"
application.register("result-history", ResultHistoryController)
import WaiverSignatureController from "./waiver_signature_controller"
application.register("waiver-signature", WaiverSignatureController)

import PiratTrendController from "./pirat_trend_controller"
application.register("pirat-trend", PiratTrendController)

import AttendanceActionsController from "./attendance_actions_controller"
application.register("attendance-actions", AttendanceActionsController)

import ConversationSettingController from "./conversation_setting_controller"
application.register("conversation-setting", ConversationSettingController)
